import { render, staticRenderFns } from "./LabaRugi.vue?vue&type=template&id=5e32b732&scoped=true"
import script from "./LabaRugi.vue?vue&type=script&lang=js"
export * from "./LabaRugi.vue?vue&type=script&lang=js"
import style0 from "./LabaRugi.vue?vue&type=style&index=0&id=5e32b732&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e32b732",
  null
  
)

export default component.exports